import { render, staticRenderFns } from "./ToDoListItem.vue?vue&type=template&id=097234fb&scoped=true"
import script from "./ToDoListItem.vue?vue&type=script&lang=js"
export * from "./ToDoListItem.vue?vue&type=script&lang=js"
import style0 from "./ToDoListItem.vue?vue&type=style&index=0&id=097234fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097234fb",
  null
  
)

export default component.exports